import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'src/domains/common/components/button/icon-button';
import { Button } from 'src/domains/common/components/button/button';
import { FiltersState } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/Filters.state';
import { ClickOutsideHandler } from 'src/domains/common/components/clickOutside';
import { MenuItemFilters } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/MenuItemFilters';
import { FilterMenuPropsType } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/filters.type';
import { MenuSeparator, MenuTitle, MenuWrapper } from 'src/domains/common/components/menu-bar/menu-bar';

export const FilterMenu = observer(({ campaignListState, submenuPosition }: FilterMenuPropsType) => {
    const [filterState] = useState(() => new FiltersState());

    return (
        <ClickOutsideHandler onClickOutside={filterState.closeFilters}>
            <div className='relative inline-block text-left'>
                <IconButton
                    onClick={filterState.toggleFilters}
                    icon='filter'
                    size='default'
                    variant='outline'
                    dataTest='filters-menu-button'
                />

                {filterState.isOpen && (
                    <MenuWrapper
                        className='absolute p-1 right-0 mt-0.5 w-[228px] z-50'
                        data-test='filter-menu'
                    >
                        <MenuTitle label='Filters' />

                        <MenuSeparator />

                        {campaignListState.filterMenuItems.map(({ label, items }) => (
                            <MenuItemFilters
                                campaignListState={campaignListState}
                                items={items}
                                key={label}
                                label={label}
                                submenuPosition={submenuPosition}
                            />
                        ))}

                        <MenuSeparator />

                        <Button
                            className='w-full'
                            onClick={() => campaignListState.clearFilters()}
                            disabled={campaignListState.isNoFilterSelected}
                            variant='ghost'
                            dataTest='clear-all-button'
                        >
                            Clear all
                        </Button>
                    </MenuWrapper>
                )}
            </div>
        </ClickOutsideHandler>
    );
});
